
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import Vue from 'vue';

window.Vue = Vue;

import GenericContext from './components/GenericContext'

import Notifications from 'vue-notification'
import RegisterVideo from './components/RegisterVideo'

import InputTextarea from './components/InputTextarea'

import Input from './components/Input'

import InputMce from './components/InputMce';

import InputSlider from './components/InputSlider'
import InputSelect from './components/InputSelect'
import ReceiverSelectChange from './components/widget/ReceiverSelectChange';

import InputSwitch from './components/InputSwitch'
import AdvanceInputSwitch from './components/AdvanceInputSwitch'

import InputAutocomplete from './components/InputAutocomplete'
import InputAddress from './components/InputAddress'
import InputTag from './components/InputTag'
import InputDate from './components/InputDate'
import InputDateBirth from './components/InputDateBirth'
import InputFile from './components/InputFile'
import InputHidden from './components/widget/InputHidden'

import Multiple from './components/Multiple'

import Modal from './components/Modal'
import FormAjax from './components/FormAjax'
import ResizeImage from './components/ResizeImage'
import ModalConfirm from './components/ModalConfirm'

import ToggleShow from './components/widget/ToggleShowComponent'

import CreditCard from './components/widget/CreditCard'
import Payment from './components/widget/Payment'

import UploadVideo from './components/widget/UploadVideo'

import ApplyJobPost from './components/widget/ApplyJobPost'

import UserNotification from './components/UserNotification'

import PageLoading from './components/PageLoading'

import FiltersComponent from './components/widget/FiltersComponent'

import Tabs from './components/Tabs'

import Slider from './components/widget/Slider'
import Chart from './components/widget/Chart'

import OverlayGallery from './components/OverlayGallery'
import RadioCustom from './components/widget/RadioCustom'

import Map from './components/Map'
import Tooltip from './components/widget/Tooltip'

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.use( Notifications );

Vue.component('generic-context', GenericContext );

Vue.component('register-video', RegisterVideo );

Vue.component('input-wf', Input );
Vue.component('textarea-wf', InputTextarea );

Vue.component('input-mce', InputMce );

Vue.component('input-slider', InputSlider );

Vue.component('input-switch', InputSwitch );
Vue.component('advance-input-switch', AdvanceInputSwitch );

Vue.component('input-select', InputSelect );
Vue.component('receiver-select', ReceiverSelectChange );

Vue.component('input-autocomplete', InputAutocomplete );
Vue.component('input-address', InputAddress );
Vue.component('input-tag', InputTag );
Vue.component('input-date', InputDate );
Vue.component('input-date-birth', InputDateBirth );
Vue.component('input-file', InputFile );
Vue.component('input-hidden', InputHidden );

Vue.component('multiple-wf', Multiple );

Vue.component('modal-wf', Modal );
Vue.component('form-ajax', FormAjax );

//Vue.component('upload-file', UploadFile );
Vue.component('resize-image', ResizeImage );

Vue.component('modal-confirm', ModalConfirm );

Vue.component('credit-card', CreditCard );
Vue.component('payment-wf', Payment );

Vue.component('upload-video', UploadVideo );
Vue.component('apply-job-post', ApplyJobPost );

//Vue.component('candidate-profile', CandidateProfile );

Vue.component('toggle-show', ToggleShow );
Vue.component('user-notification', UserNotification );

Vue.component('page-loading', PageLoading );

Vue.component('filters', FiltersComponent );

Vue.component('tabs-wf', Tabs );

Vue.component('slider', Slider );
Vue.component('chart', Chart );

Vue.component('overlay-gallery', OverlayGallery );
Vue.component('radio-custom', RadioCustom );

Vue.component('map-component', Map );
Vue.component('tooltip', Tooltip );


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

(( window, $ ) => {

    const app = new Vue({
        el: '#app'
    });

})( window, window.jQuery );


